module.exports = __webpack_public_path__ + "static/media/logo_bz.fd2ba90d.png";